import { formatISO, startOfMinute } from "date-fns";

import { SideNavigationLink } from "../../../components/SideNavigation";
import { EmployeeGoalsFilter } from "./Filters";

import getPossessiveNameCase from "../../../utils/getPossessiveNameCase";

const formatDateType = (date: Date) => {
	return formatISO(startOfMinute(date));
};

export const getFiltersForSearchService = (
	filters: Partial<EmployeeGoalsFilter>,
	employeeID: string,
	pageName = "mygoals",
	directReports: string[] = [],
	searchValue = ""
) => {
	const finalFilters = {};

	finalFilters["user_being_viewed"] = employeeID;

	if (pageName === "mygoals") {
		finalFilters["assignee_or_sharers_in"] = [employeeID];
	} else if (pageName === "teamGoals") {
		finalFilters["assignee_in"] = directReports;
	}

	if (filters.assignee && filters.assignee.length > 0) {
		let pickedAssignees = filters.assignee?.map((assignee) => assignee.id);
		if (pageName === "teamGoals") {
			pickedAssignees = pickedAssignees?.filter((assignee) => {
				return directReports?.includes(assignee);
			});
		}

		finalFilters["assignee_in"] = pickedAssignees;
	}

	if (filters?.createdDateAfter) {
		finalFilters["created_gt"] = formatDateType(filters?.createdDateAfter);
	}

	if (filters?.createdDateBefore) {
		finalFilters["created_lt"] = formatDateType(filters?.createdDateBefore);
	}

	if (filters?.dueDateAfter) {
		finalFilters["end_date_gt"] = formatDateType(filters?.dueDateAfter);
	}

	if (filters?.dueDateBefore) {
		finalFilters["end_date_lt"] = formatDateType(filters?.dueDateBefore);
	}

	if (filters?.category) {
		finalFilters["categories_in"] = filters?.category?.map((category) => category.id) || [];
	}

	if (filters?.status) {
		finalFilters["status_in"] = filters?.status || [];
	}

	if (filters?.transparency) {
		finalFilters["transparency_in"] = filters?.transparency || [];
	}

	if (filters?.outlook) {
		finalFilters["color_in"] = filters?.outlook?.map((outlook) => outlook.id) || [];
	}

	if (filters?.showSharedOnly && filters.showSharedOnly.length > 0) {
		finalFilters["is_shared_eq"] = true;
	}

	if (filters?.unseenUpdatesOnly && filters.unseenUpdatesOnly.length > 0) {
		finalFilters["has_updates_eq"] = true;
	}

	if (filters?.alignedTo) {
		finalFilters["ancestors_in"] = [filters?.alignedTo.id];
	}

	if (searchValue) {
		finalFilters["name_re"] = searchValue;
	}
	return finalFilters;
};

export const getUserGoalsNavigationLinks = (
	userId: string,
	employeeId: string,
	employeeName?: string,
	hasDirectReports = false
): SideNavigationLink[] => {
	const navLinks: SideNavigationLink[] = [];
	const statusFilter = { status: ["active"] };
	navLinks.push({
		label: `${userId === employeeId ? "My" : employeeName} Goals`,
		href: `/employees/${employeeId}/goals/mygoals/?filters=${JSON.stringify(statusFilter)}`,
		key: "mygoals",
	});
	if (hasDirectReports) {
		navLinks.push({
			label: `${userId === employeeId ? "My" : getPossessiveNameCase(employeeName || "")} Team Goals`,
			href: `/employees/${employeeId}/goals/teamGoals/?filters=${JSON.stringify(statusFilter)}`,
			key: "teamGoals",
		});
	}

	return navLinks;
};
